module.exports = __webpack_public_path__ + "img/2nd.44b54290.png";